import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { useMatchCompare } from 'projectSpecific/sports/useHelpers/useMatchCompare'
import React, { useContext, useMemo, useState } from 'react'
import { Icon, Label } from 'semantic-ui-react'
import _ from 'lodash'
import { CreatePlayoffContext } from 'projectSpecific/sports/create/CreatePlayoff'

export const TeamOpps = ({ team, oppTeam, oppTeams, noMid, excludeSection = true }) => {

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { matches_info, teams_info } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { matches_groupInfo } = matches_info ?? {};
  const { matches_combined: matches } = matches_groupInfo ?? {};

  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}
  const { playoff_info } = createPlayoff_state ?? {}
  const { playoffLevel, playoffLevelTeams } = playoff_info ?? {}
  const teams_playoffGroup = playoffLevelTeams?.[playoffLevel]
  const tpgk = teams_playoffGroup ? _.map(teams_playoffGroup, t => t._itemKey) : []

  const [excludeSectionMatches, setExcludeSectionMatches] = useState(excludeSection)
  const umc = useMatchCompare({ matches, teams })

  const selectedOppTeamsWithMatches = useMemo(() => {
    const _oppTeamWithMatches = umc.getFilteredOpponentsWithMatches({ teamKey: team?._itemKey, excludeSectionMatches, tpgk })
    return _oppTeamWithMatches
  }, [team, excludeSectionMatches, oppTeam])

  const handleExcludeSectionMatches = () => setExcludeSectionMatches(!excludeSectionMatches)

  const lbl = <Label
    style={{ float: 'right' }}
    size='tiny'
    color={excludeSectionMatches ? 'blue' : 'grey'}
    onClick={() => { handleExcludeSectionMatches() }}>
    <Icon name={excludeSectionMatches ? 'check circle' : 'circle outline'} />
    {_.startCase('excludeSectionMatches')}
  </Label>

  const div_matches = (matches) => {
    return _.map(matches, m => {
      if (m.complete) {
        return <Label size='tiny' color={m.win ? 'green' : 'red'}>{m.score}</Label>
      } else {
        return <Label size='tiny' color={'black'}>{m.startDate}</Label>
      }
    })
  }

  const teamComps = () => {
    const divs = []
    if (selectedOppTeamsWithMatches) {

      const _tmz = _.sortBy(selectedOppTeamsWithMatches, 'name')

      _.forEach(_tmz, (opp) => {

        const { commonOpponents, matches_direct, _itemKey: oppKey } = opp ?? {}

        if (oppTeam && oppTeam?._itemKey !== oppKey) return;

        const divs_teams = []

        divs_teams.push(<div className='match-opp-match hdr'>
          {/* <div>{`${teams?.[oppKey]?.name}`}</div> */}
          <div>{teams?.[oppKey]?.name}</div>
          {/* <div>{`${teams?.[team?._itemKey]?.name}`}</div> */}
        </div>)

        divs_teams.push(<div className='match-opp-matches direct'>
          <div>{`${teams?.[oppKey]?.name}`}</div>
          <div className={'mgc-opp'}>{div_matches(matches_direct)}</div>
          <div>{`${teams?.[team?._itemKey]?.name}`}</div>
        </div>)

        _.forEach(commonOpponents, (commonOpp, commonOppKey) => {
          const { matches_opp, matches_vs } = commonOpp ?? {}
          divs_teams.push(<div className='match-opp-matches'>
            <div className={'mgc-opp'}>{div_matches(matches_opp)}</div>
            <div>{teams?.[commonOppKey]?.name}</div>
            <div className={'mgc-opp'}>{div_matches(matches_vs)}</div>
          </div>)
        })

        divs.push(<div className='match-opp-teams'>
          {divs_teams}
        </div>)
      })
    }
    return divs
  }

  const wrapper_common = () => <Wrapper
    header={<div className={'header-flex'}>
      <div></div>
      {lbl}
    </div>}
    content={teamComps()}
    noMid={noMid}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  return wrapper_common()

}
